<!-----------------fillering------------------->
<div class="card-body">
    <div class="row">
    <div class="col-md-6">
  
    <div class="form-group">
        <label>Select Department</label>
    
        <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible size" data-select2-id="1" tabindex="-1" aria-hidden="true">
        <option selected="selected" data-select2-id="1">ALL</option>
        <option *ngFor="let d of department" data-select2-id="2">{{d.department_name}}</option>
       
        <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
        </select>
        
        <span class="dropdown-wrapper" aria-hidden="true"></span>
    </div>
    
    
    
    </div>

    <div class="col-md-6">
    <div class="form-group">
   
        <div class="form-group">
            <label>Search Employee</label>
           
            <div class="input-group">
                <input  type="search" class="form-control form-control-lg " placeholder="Search Employee" id="search" name="search" [(ngModel)]="search" (ngModelChange)="Search();">
                <div class="input-group-append">
                <button type="submit" class="btn btn-lg btn-default " (click)="Search();">
                <i class="fa fa-search"></i>
                </button>
                </div>
            </div>
        </div>
    </div>
   
    </div>
  


   
<!---------------------------------new ui---------------------------------------------------->
 

    <section class="content-header ">
         <div class="row mb-2 ">
        <div class="col-sm-6">     
        <h1>Employees</h1>
    
        </div>
        </div>
        </section>
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
        
    <section class="content">
    
    <div class="card" *ngIf=CardShown>
    <div class="card-header">
    <!--
    <h3 class="card-title Title">Employee Listing</h3>
    -->
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 35%">
    Name
    </th>

    <th style="width: 25%">
    Department
    </th>

    <th style="width: 15%">
    Role
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
        {{c.employee_name}}
    </a>
    </td>
    
    <td>
        {{c.department}}
    </td>

    
    <td>
        {{c.role}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)="employeeDetails();getValue(c.employee_id)">
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='EditEmployee();getValue(c.employee_id);'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    <!--
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    -->
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
    
   
<!-------------------------------paging--------------------------------------------------------->
<div *ngIf=CardShown>
<div class="row">
    <div class="col-sm-12 col-md-5">
    <div class="col-sm-12 col-md-7"><div class="dataTables_paginate paging_simple_numbers " id="example2_paginate">
    </div></div></div></div>


    <div class="col-sm-12 col-md-7">
        <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
            <ul class="pagination ">
                <li class="paginate_button page-item previous" id="example2_previous">
                <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>

                <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
               
                <li class="paginate_button page-item next" id="example2_next">
                <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
            </ul>
        </div>
    
    </div>
 
</div>
      
